import { Link } from "react-router";

import { buttonClass } from "@/components/ui";
import type { SupportContext } from "@/lib/supportContext";

/** A failure screen's way out that is never a dead end: opens the real support request form with the
 * Subject already carrying what broke, instead of a bare `mailto:` that loses that context. Replaces
 * every ad hoc "Contact support" link across the app (PHP-3084). */
export function GetHelpLink({
  context,
  variant = "secondary",
  size = "lg",
  className,
  children = "Contact support",
}: {
  context: SupportContext;
  variant?: Parameters<typeof buttonClass>[0];
  size?: Parameters<typeof buttonClass>[1];
  className?: string;
  children?: string;
}) {
  return (
    <Link to="/support" state={{ supportContext: context }} className={buttonClass(variant, size, className)}>
      {children}
    </Link>
  );
}
